export default {
	TITLE: 'Translations',
	PRODUCT_TRANSLATIONS_ADDED: 'Translations added!',
	PRODUCT_TRANSLATION_EDIT: 'Translation edited!',
	PRODUCT_TRANSLATIONS_EDIT: 'Translations edited!',
	PRODUCT_TRANSLATIONS_DELETED: 'Translations deleted!',

	// batch form
	MODAL_BATCH_STEP_FORM_TITLE: 'Select languages',
	MODAL_BATCH_STEP_FORM_CONFIRM_BUTTON_LABEL: 'Next',
	MODAL_HEADER_LANGUAGE: 'Language',
	MODAL_HEADER_LANGUAGE_PLACEHOLDER: 'Select languages...',
	MODAL_BATCH_STEP_LIST_TITLE: 'Add translations',
	MODAL_BATCH_STEP_LIST_TABLE_NUMBER: '#',
	MODAL_BATCH_STEP_LANGUAGE: 'Language',
	MODAL_BATCH_STEP_LIST_CONFIRM_BUTTON_LABEL: 'Add entries',
	MODAL_BATCH_STEP_LIST_NAME: 'Name',
	MODAL_BATCH_STEP_LIST_NAME_PLACEHOLDER: 'Enter name...',
	MODAL_BATCH_STEP_LIST_DESCRIPTION: 'Description',
	MODAL_BATCH_STEP_LIST_DESCRIPTION_PLACEHOLDER: 'Enter description...',
	LANGUAGES_TABLE_TITLE: 'Languages',
};
